<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	name: 'Product Name',
	imageURL: '/og.jpg',
}
const schema = defineSchema({
	name: $.text('Title'),
	imageURL: $.upload('Image'),
})
export const BlockProductHero = defineBlock({
	pickerHidden: true,
	thumbnail: '/block-thumbs/BlockProductHero.svg',
	category: 'Hero',
	order: 380,
	name: 'BlockProductHero',
	label: 'Product Hero',
	icon: 'storefront',
	schema,
	defaults,
})
</script>
<script setup lang="ts">
import { computed } from 'vue'

import { Image } from '@bagelink/vue'
import { useBoundPageItem } from '@/composables/useBoundPageItem'
import { displayImage } from '@/utils/image'

/**
 * Generic centered hero: a title over a product/cover image on a gray band.
 * Reusable for store products, book pages, campaign covers, etc.
 *
 * Reads the bound datastore item ($page) when a collection is bound in the
 * designer, else falls back to the editor-provided props.
 */




const props = defineProps<{
	name?: string
	imageURL?: string
}>()

const bound = useBoundPageItem<Record<string, any>>()

const title = computed(() => bound.value?.name || bound.value?.title || props.name || '')
const image = computed(
	() => bound.value?.image?.imageURL || bound.value?.image || props.imageURL || '',
)
</script>

<template>
	<div class="txt-center bg-gray-60 py-3 m_py-2 px-1">
		<div class="w760px mx-auto">
			<h1 class="m-0 txt-40 regular line-height-12 m_txt-32 pb-2 m_pb-1">
				{{ title }}
			</h1>
			<Image v-if="image" :src="displayImage(image, 'content')" :alt="title" class="w-100p w650px mx-auto" lazy />
		</div>
	</div>
</template>
